import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import { map, Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Policy } from "../models/policy";
import { PolicyChangeLog } from "../models/policy-change-log.model";
import { PolicyDetail } from "../models/policy-details";
import { PolicyFieldsVM } from "../models/policy-field-vm.model";
import { PolicyReceiptsYearVm } from "../models/policy-receipts.model";
import { ComputePolicyUpdateCommand, UpdatePolicyCommand } from "../models/policy-update-command.model";
import { PolicyWait4SignEndorsement } from "../models/policy-wait4sign-endorsement.model";

@Injectable({
  providedIn: "root",
})
export class PolicyService {
  private readonly policiesUrl = "policies";
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient) {
    this.baseUrl = environment.apiConfig.uri + this.policiesUrl;
  }

  getPolicies(): Observable<Policy[]> {
    return this.http.get<Policy[]>(this.baseUrl + "/me").pipe(map(result => result ?? []));
  }

  getPolicyId(reference: string): Observable<string> {
    return this.http.get<string>(this.baseUrl + "/" + reference + "/id");
  }

  getPolicyDetails(id: Guid): Observable<PolicyDetail> {
    return this.http.get<PolicyDetail>(this.baseUrl + "/" + id + "/me");
  }

  getMemberReceiptsByPolicyId(id: Guid): Observable<PolicyReceiptsYearVm[]> {
    return this.http.get<PolicyReceiptsYearVm[]>(this.baseUrl + "/" + id + "/payment-schedules/me");
  }

  getPolicyFields(id: Guid): Observable<PolicyFieldsVM> {
    return this.http.get<PolicyFieldsVM>(this.baseUrl + "/" + id + "/fields");
  }

  getFields(id: Guid): Observable<any> {
    return this.http.get<any>(this.baseUrl + "/" + id + "/fields");
  }

  computePolicyUpdate(computePolicyUpdateCommand: ComputePolicyUpdateCommand): Observable<PolicyChangeLog> {
    return this.http.patch<PolicyChangeLog>(this.baseUrl + "/changes/me", computePolicyUpdateCommand);
  }

  updatePolicy(updatePolicyCommand: UpdatePolicyCommand): Observable<any> {
    return this.http.patch<any>(this.baseUrl + "/me", updatePolicyCommand);
  }

  // TODO: Vérifier si le endpoint est correct avec le back mergé du lot 1.1
  getPolicyWait4SignEndorsement(): Observable<PolicyWait4SignEndorsement[]> {
    return this.http.get<PolicyWait4SignEndorsement[]>(this.baseUrl + "/policyWait4SignEndorsement/me");
  }
}
